<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div class="vertical-center center">
  <mat-card class="upload-card">
    <mat-card-header>
      <mat-card-title>Upload Image</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div>
        <div class="center">
          @if (providedImage) {
            <div class="image-preview">
              <img [src]="parsedImage" alt="Selected Image" />
            </div>
          } @else {
            <button mat-button class="image-placeholder" (click)="files.click()">
              <mat-icon>photo</mat-icon>
              Touch to upload from gallery
            </button>
          }
        </div>
      </div>
      <input
        type="file"
        accept="image/*"
        capture="environment"
        hidden
        #camera
        (change)="onFileSelected($event)"
      />
      <input
        type="file"
        accept="image/*"
        hidden
        #files
        (change)="onFileSelected($event)"
        data-cy="image-upload-file-input"
      />

      <mat-form-field class="full-width" [appearance]="'outline'">
        <mat-label>Author</mat-label>
        <input matInput [(ngModel)]="author" maxlength="30" />
        <mat-hint align="end">{{ author?.length || 0 }}/30</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width" [appearance]="'outline'">
        <mat-label>Title</mat-label>
        <input matInput [(ngModel)]="title" maxlength="50" />
        <mat-hint align="end">{{ title?.length || 0 }}/50</mat-hint>
      </mat-form-field>

      <div class="buttons">
        <button mat-mini-fab color="primary" (click)="camera.click()" aria-label="Take picture">
          <mat-icon>camera_alt</mat-icon>
        </button>
        <div>
          <button mat-flat-button (click)="uploadImage()">
            <mat-icon>upload</mat-icon> Upload
          </button>
          <button mat-raised-button (click)="clear()" class="margin-left delete-button">
            <mat-icon>delete</mat-icon> Clear
          </button>
        </div>
      </div>
    </mat-card-content>
    <mat-card-footer class="footer">
      @if (errorMessage !== '') {
        <div>{{ errorMessage }}</div>
      }
    </mat-card-footer>
  </mat-card>
</div>
